import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const TrophyIcon = styled.div`
  ${(props) =>
    props.itemColor &&
    css`
      width: 32px;
      height: 32px;
      border-radius: 50%;
      position: relative;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
      position: absolute;
      left: 0;

      &:before {
        content: '';
        position: absolute;
        background: ${colors.fsLightBlue};
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: -1;
      }

      &:after {
        content: '\f091';
        font-family: 'FontAwesome';
        position: absolute;
        color: white;
        opacity: 0.75;
        font-size: 16px;
      }

      ${(props) =>
        props.itemColor === 'gold' &&
        css`
          background: linear-gradient(-45deg, rgb(240, 199, 0), rgba(240, 199, 0, 0.2), rgb(240, 199, 0));
          border: 1px solid rgb(240, 199, 0);
        `}

      ${(props) =>
        props.itemColor === 'silver' &&
        css`
          background: linear-gradient(-45deg, rgb(112, 112, 112), rgba(112, 112, 112, 0.2), rgb(112, 112, 112));
          border: 1px solid rgb(112, 112, 112);
        `}

      ${(props) =>
        props.itemColor === 'bronze' &&
        css`
          background: linear-gradient(-45deg, rgb(214, 129, 0), rgba(214, 129, 0, 0.2), rgb(214, 129, 0));
          border: 1px solid rgb(214, 129, 0);
        `}
      ${(props) =>
        props.itemColor === 'iron' &&
        css`
          background: linear-gradient(-45deg, rgb(0, 184, 184), rgba(0, 184, 184, 0.2), rgb(0, 184, 184));
          border: 1px solid rgb(0, 184, 184);

          &:after {
            content: '\f21e';
            font-family: 'FontAwesome';
            position: absolute;
            color: white;
            opacity: 0.75;
            font-size: 16px;
          }
        `}
    `}
`;

export const SortArrows = styled.img`
  height: 10px;
  width: 10px;
  margin-left: 5px;
  cursor: pointer;
`;

export const TableContainer = styled.div`
  background: ${({ theme }) => theme.table.background};
  border-radius: 24px;
  width: 100%;
  padding: 0 5px 20px;
`;

export const TableRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 0;
`;

export const TableCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.info};

  ${({ flexWidth = '7' }) => css`
    flex: 0 0 ${flexWidth}%;
    max-width: ${flexWidth}%;
  `}

  ${({ mobileFlexWidth }) =>
    mobileFlexWidth &&
    css`
      @media (max-width: 767px) {
        flex: 0 0 ${mobileFlexWidth}%;
        max-width: ${mobileFlexWidth}%;
      }
    `}

  ${({ isScore }) =>
    isScore &&
    css`
      cursor: pointer;
    `}

  ${({ alignLeft }) =>
    alignLeft &&
    css`
      justify-content: left;
    `}


  ${({ mobileHide }) =>
    mobileHide &&
    css`
      @media (max-width: 767px) {
        display: none;
      }
    `}
`;

export const TableActions = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 1rem;
  font-size: 14px;

  & button:nth-child(n + 2) {
    margin-top: 0.5rem;
  }
`;

export const ChallengeTableHeader = styled.div`
  font-size: 1.125rem;
  margin-right: 0 !important;
  margin-left: 0 !important;
  width: 100%;
  padding: 0.75rem 0;
  border-radius: 8px;

  ${({ isGrey, theme }) => css`
    background-color: ${isGrey ? theme.table.secondBackground : theme.table.background};
  `}

  ${({ ineligible }) =>
    ineligible &&
    css`
      background-color: ${colors.lightRed5};
    `}
`;

export const NameLink = styled.a`
  color: ${({ theme }) => theme.info};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.info};
    text-decoration: none;
  }
`;

export const TotalSubmits = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  height: 100%;
`;

export const ViewGameContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const RankListPlayerContainer = styled.div`
  margin-bottom: 1px;
`;

export const TrendIcon = styled.i.attrs(({ isUp, isDown }) => ({
  className: isUp ? 'fa fa-arrow-circle-up' : isDown ? 'fa fa-arrow-circle-down' : 'fa fa-circle-minus',
}))`
  font-size: ${({ isHackathon }) => (isHackathon ? '40px' : '22px')};
  position: relative;
  left: ${({ isHackathon }) => (isHackathon ? '0px' : '-35px')};
  top: 17px;
  @media (max-width: 768px) {
    display: none;
  }

  color: ${colors.lightGray2};

  ${({ isUp }) =>
    isUp &&
    css`
      color: ${colors.green2};
    `}

  ${({ isDown }) =>
    isDown &&
    css`
      color: ${colors.red};
    `}
`;

export const LanguageIcon = styled.i.attrs(({ className }) => ({
  className: className,
}))`
  font-size: 30px;
  margin-right: 10px;
  ${({ isHackathon }) =>
    isHackathon &&
    css`
      font-size: 40px;
    `}

  @media (max-width:575px) {
    display: none;
  }
`;

export const SearchBarContainer = styled.div`
  float: right;
  margin-top: -58px;

  @media (max-width: 768px) {
    margin-top: 0;
    margin-bottom: 10px;
    float: none;

    & > div {
      max-width: 100%;
    }
  }
`;

export const AvatarImage = styled.img`
  border-radius: 50%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: inline-block;
  width: 56px;
  height: 56px;
  vertical-align: top;
  margin-right: 25px;

  @media (max-width: 575px) {
    display: none;
  }
`;

export const ActionButton = styled.button`
  color: ${({ isDarkMode }) => (isDarkMode ? colors.white : colors.darkGray11)};
  background: ${({ isDarkMode }) => (isDarkMode ? colors.darkGray10 : colors.lightGray9)};
  border: 1px solid ${({ isDarkMode }) => (isDarkMode ? colors.darkGray5 : colors.lightGray9)};
  border-radius: 8px;
  margin: 0;
  padding: 0.375rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;

  &:hover {
    background: ${({ isDarkMode }) => (isDarkMode ? colors.darkGray10 : colors.lightGray9)};
    border: 1px solid ${({ isDarkMode }) => (isDarkMode ? colors.darkGray5 : colors.lightGray9)};
  }

  &:focus {
    outline: 0 none !important;
    box-shadow: none;
  }
`;

export const LanguageSelectContainer = styled.div`
  width: 100%;
  & label {
    color: ${({ theme }) => theme.info};
  }
  & button {
    width: 100%;
  }
`;
